import React from "react";
import { Link } from "react-router-dom";
import "./TrabajadorDashboard.css";

const TrabajadorDashboard = () => {
    return (
        <div className="trabajador-dashboard">
            <h1>Panel del Trabajador</h1>
            <div className="trabajador-dashboard-grid">
                <Link to="/Pedidos" className="trabajador-dashboard-card">
                    <span role="img" aria-label="Pedidos">📦</span>
                    <h2>Pedidos y Despachos</h2>
                    <p>Gestiona los pedidos y envíos.</p>
                </Link>
                
                <Link to="/mis-comisiones" className="trabajador-dashboard-card">
                    <span role="img" aria-label="Comisiones">💰</span>
                    <h2>Mis Comisiones</h2>
                    <p>Consulta tus comisiones y pagos.</p>
                </Link>
            </div>
        </div>
    );
};

export default TrabajadorDashboard;